import { API_CONFIG, buildApiUrl, getAuthHeaders, getDefaultHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

// Types for Site Config API
export interface MenuItem {
  name: string;
  description?: string; // Optional field
  price: string;
  day?: string; // Optional field - day of the week this special applies to
  category?: string; // 'dessert' marks this as a dessert item; otherwise treated as a food special
}

export interface DailySpecialRequest {
  menu_items: MenuItem[];
}

export interface DailySpecialResponse {
  id: number;
  name: string;
  jsonData: {
    menu_items: MenuItem[];
  };
  createdAt: number;
  updatedAt: number;
}

// Site Config API calls
export const siteConfigApi = {
  // Get daily special
  getDailySpecial: async (): Promise<DailySpecialResponse> => {
    return apiRequest<DailySpecialResponse>(
      buildApiUrl(API_CONFIG.ENDPOINTS.SITE_CONFIG.DAILY_SPECIAL),
      {
        method: 'GET',
        headers: getDefaultHeaders(),
      }
    );
  },

  // Create or update daily special
  saveDailySpecial: async (
    data: DailySpecialRequest,
    token: string
  ): Promise<DailySpecialResponse> => {
    return apiRequest<DailySpecialResponse>(
      buildApiUrl(API_CONFIG.ENDPOINTS.SITE_CONFIG.DAILY_SPECIAL),
      {
        method: 'POST',
        headers: getAuthHeaders(token),
        body: JSON.stringify(data),
      }
    );
  },
};

